import { traceQuery, useDeleteTraceMutation } from "@common/api"
import { handleError } from "@common/utils"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import useCustomToast from "@/hooks/use-custom-toast"
import { DeleteTraceDialog } from "@/routes/_layout/agent/-components/delete-trace-dialog"

export const Route = createFileRoute("/_layout/agent/delete/$id")({
  component: DeleteTraceModal,
})

function DeleteTraceModal(): React.ReactElement {
  const { id } = Route.useParams()
  const navigate = useNavigate()
  const showToast = useCustomToast()

  const { data: trace } = useQuery(traceQuery({ id }))
  const deleteMutation = useDeleteTraceMutation()

  const close = () => navigate({ to: "/agent" })

  const handleConfirm = () => {
    deleteMutation.mutate(
      { id },
      {
        onSuccess: close,
        onError: (err) => handleError(err, showToast),
      },
    )
  }

  return (
    <DeleteTraceDialog
      open
      onOpenChange={(open) => !open && close()}
      trace={trace ?? null}
      isDeleting={deleteMutation.isPending}
      onConfirm={handleConfirm}
    />
  )
}
